const audioSuccess = new Audio('/static/scan_success.mp3');
const audioFail = new Audio('/static/scan_fail.mp3');
const audiod2dPU = new Audio('/static/d2d_pu.m4a');
const audiod2dZH = new Audio('/static/d2d_zh.MP3');

function audioSuccessPlay() {
  audioSuccess.play();
}

function audioFailPlay() {
  audioFail.play();
}

function audiod2dPUPlay() {
  audiod2dPU.play();
}
function audiod2dZHPlay() {
  audiod2dZH.play();
}

export { audioSuccessPlay, audioFailPlay, audiod2dPUPlay, audiod2dZHPlay };
